<template>
  <div class="edit">
    <CloseModalBtn :closeModal="closeModal" />
    <h5>
      {{
        create
          ? localStorage.translations.pages.personnel_department[
              'employees-group_dialog_create-edit'
            ]['cozdat-podrazdelenie']
          : localStorage.translations.pages.personnel_department[
              'employees-group_dialog_create-edit'
            ]['redaktirovat-podrazdelenie']
      }}
    </h5>
    <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="createOrUpdate" class="d-grid gap-5">
      <BaseInput
        :label="localStorage.translations.pages.personnel_department[
            'employees-group_dialog_create-edit_labels'
          ]['nazvanie']"
        v-model="name"
        :rules="['required']"
      />
      <BaseInput
        type="select"
        :label="localStorage.translations.pages.personnel_department[
            'employees-group_dialog_create-edit_labels'
          ]['sotrudniki']"
        v-model="employeesPick"
        :rules="['required']"
        :items="employeesReady"
        append-icon="fas fa-angle-down"
        :item-value="(i) => i.id"
        :item-text="(i) => (i.user ? i.user.first_name + ' ' + i.user.last_name : null)"
        multiple
        chips
        deletable-chips
      />
      <div class="container_btn">
        <BaseButton
          type="submit"
          :text="
            create
              ? localStorage.translations.pages.personnel_department[
                  'employees-group_dialog_create-edit_buttons'
                ]['sozdat-podrazdelenie']
              : localStorage.translations.pages.personnel_department[
                  'employees-group_dialog_create-edit_buttons'
                ]['sohranit']
          "
          :default_icon="create ? 'button-add' : 'button-save'"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import CloseModalBtn from 'components/CloseModalBtn'
import BaseInput from "components/base/BaseInput";

export default {
  name: 'EmployeesGroupCreateAndEditModalForm',
  components: {BaseInput, CloseModalBtn },
  props: ['id', 'dialog', 'closeModal', 'create'],

  data() {
    return {
      valid: true,
      name: '',
      employee_id: '',
      employee_role_id: '',
      employeesPick: [],
      employeesReady: [],
    }
  },
  created() {
    this.onEmployeeAll()
    this.onDownloadData()
  },
  mounted() {
    if (!this.create && this.employeeGroupShow) {
      this.name = this.employeeGroupShow.name
      this.employeesPick = this.employeeGroupShow.employees.map((i) => i.id)
    }
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('employee', ['employeeAll']),
    ...mapGetters('employeeGroup', ['employeeGroupShow']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
  watch: {
    employee_id() {
      let employeeSelect = this.employeeAll.find((i) => i.id === this.employee_id)

      this.employee_role_id =
        employeeSelect.employee_role_id !== 0 ? employeeSelect.employee_role_id : ''
    },
  },
  methods: {
    ...mapActions('employee', [
      'onEmployeeAll',
      'onEmployeeListGroupsAndWorkTypes',
    ]),
    ...mapActions('employeeRoles', ['onEmployeeRolesAll']),
    ...mapActions('employeeGroup', [
      'onEmployeeGroupGrid',
      'onEmployeeGroupShow',
      'onEmployeeGroupCreate',
      'onEmployeeGroupUpdate',
    ]),
    validate() {
      this.$refs.form.validate()
    },
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      // if (this.filterParams.length) {
      //     data.filters = this.filterParams
      // }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onEmployeeGroupGrid(data)
    },
    onDownloadData() {
      let employeeslistFull = []
      this.onEmployeeListGroupsAndWorkTypes({
        limit: 0,
        page: 1,
        filters: '&filter[]=group_id:0',
      }).then((resp) => {
        employeeslistFull.push(...resp.data.data)
      })
      if (!this.create) {
        this.onEmployeeListGroupsAndWorkTypes({
          limit: 0,
          page: 1,
          filters: '&filter[]=group_id:' + this.$route.params.id,
        }).then((resp) => {
          employeeslistFull.push(...resp.data.data)
        })
      }

      return (this.employeesReady = employeeslistFull)
    },
    async createOrUpdate() {
      await this.validate()
      if (this.valid === true) {
        if (this.create) {
          let data = {
            name: this.name,
            employees: this.employeesPick,
          }
          this.onEmployeeGroupCreate(data)
            .then((response) => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common['notifications'][
                      'uspeshno-cozdano'
                    ],
                  IsError: false,
                },

                { root: true },
              )
              this.downloadPageData()
              this.closeModal()
            })
            .catch((err) => {
              // if (err.data.message == 'Is in another group.') {
              //     this.$store.dispatch(
              //         'popup/onMessage',
              //         {
              //             message: 'Ошибка, сотрудник(и) ' + err.data.name + ' уже находятся в подразделении',
              //             IsError: true,
              //         },
              //         { root: true }
              //     )
              // }
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common['notifications']['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            })
        } else {
          let data = {
            id: this.employeeGroupShow.id,
            name: this.name,
            employees: this.employeesPick,
          }
          this.onEmployeeGroupUpdate(data)
            .then((response) => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common['notifications'][
                      'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },

                { root: true },
              )
              this.onEmployeeGroupShow(this.employeeGroupShow.id)
              this.closeModal()
            })
            .catch((err) => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message: this.localStorage.translations.pages.common['notifications']['oshibka'],
                  IsError: true,
                },
                { root: true },
              )
            })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.edit {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: center;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }
  h5 {
    text-align: center;
    margin-bottom: 50px;
  }
  form {
    text-align: left;
    display: grid;
    grid-column-gap: 30px;
    grid-row-gap: 10px;
    label {
      line-height: 26px;
      color: #52525f;
    }

    .v-text-field {
      padding-top: 0px;
      margin-top: 0px;
      fieldset {
        border: 1px solid #b4b4b4;
        border-radius: 4px;
      }
      .theme--light.v-icon {
        color: #b4b4b4;
      }
    }
    .container_btn {
      display: grid;
      justify-content: center;
      margin-top: 30px;
    }
    .v-input--selection-controls {
      margin-top: 0;
    }
  }
}
</style>
